export interface WebSocketConfig {
  endpoint: string
  reconnectDelay?: number
  heartbeatIncoming?: number
  heartbeatOutgoing?: number
  debug?: boolean
}

export interface CoreNotifyEvent {
  type: string
  data: any
  timestamp?: number
  /**
   * WS destination core / platform sessionId
   * (`/client/event/app/{coreId}` или `/client/event/form/{coreId}`).
   */
  coreId?: string
}

export interface HeartbeatMessage {
  timestamp: number
  sessionId?: string
  activeCores?: string[]
}

export interface TaskResult {
  taskId: string
  result: any
  error?: any
}

export enum ScriptLevel {
  FORM = 'FORM',
  PAGE = 'PAGE',
  PANEL = 'PANEL',
  ELEMENT = 'ELEMENT',
  ACTION = 'ACTION'
}

export enum ScriptName {
  ON_LOAD = 'onLoad',
  ON_PAGE_SELECT = 'onPageSelect',
  DATA_PROCESS = 'dataProcess',
  PREPROCESS_CLIENT_STORING_DATA = 'preprocessClientStoringData',
  ON_CHANGE = 'onChange',
  ON_SELECTION_CHANGED = 'onSelectionChanged',
  ON_CLICK = 'onClick',
  ON_INLINE_MENU_SHOW = 'onInlineMenuShow',
  ON_INLINE_DO_FIRST_ACTION = 'inlineDoFirstAction',
  EVENT_DIALOG_CLOSED = 'event.dialogClosed',
  EVENT_CHAIN_CALLED = 'event.chainCalled',
  EVENT_DIALOG_CLOSED_N_RETURN = 'event.dialogClosedNReturn',
  EVENT_SELECTION_CHANGED = 'event.selectionChanged',
  ON_IMPORT = 'onImport',
  ON_FOCUS_GAINED = 'onFocusGained',
  ON_FOCUS_LOST = 'onFocusLost',
  INLINE_AFTER_LOAD = 'inlineAfterLoad',
  EVENT_ON_CHANGE = 'event.onChange',
  EVENT_FILL = 'event.fill',
  EVENT_FILLED = 'event.filled',
}

// Тело запроса на выполнение скрипта
export interface ExecuteScriptRequest {
  type: string
  sessionId: string
  socketId: string
  isClone: boolean
  currentData: any
  elementId: number
  level: ScriptLevel
  scriptName?: ScriptName
  scriptBody?: string
  cloneOf?: string
}

export interface JsRequest {
  taskId?: string
  className?: string
  class_name?: string
  methodName?: string
  method_name?: string
  request_id?: string
  objectId?: string | number
  object_id?: string | number
  paramTypes?: string[]
  param_types?: string[]
  args?: Array<any | { type?: string; value?: any }>
  changedData?: any
  changed_data?: any
  socketId?: string
  socket_id?: string
  /** coreId подписки `/client/task/js-request/{coreId}` — sessionId формы на middleware. */
  coreSessionId?: string
}

export enum WebSocketStatus {
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  ERROR = 'ERROR',
  RECONNECTING = 'RECONNECTING'
}

export interface WebSocketState {
  status: WebSocketStatus
  connected: boolean
  error: string | null
  reconnectAttempts: number
}


